module.exports = __webpack_public_path__ + "static/media/map-pin-chauffeur.f67a52b2.svg";